import graphqlClient from "@/GQLClient";
import type { PeopleGroup } from "@/graphql";
import { GetEmployeesAndResidentsDocument } from "@/graphql/generated-types";
import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";

const getEmployeesAndResidents = async (): Promise<PeopleGroup> => {
  const response = await graphqlClient.query({
    query: GetEmployeesAndResidentsDocument,
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  });

  if (response.error) {
    throw new SentryGraphQLError(`api.profile.getProfiles`, response);
  }

  return {
    employees: response.data.institutions?.getMyInstitution?.employees || [],
    residents: response.data.institutions?.getMyInstitution?.residents || [],
  };
};

export default {
  getEmployeesAndResidents,
};
